// src/App.js
import React from 'react';
import NumberSystemCalculator from './NumberSystemCalculator';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="NumberSystemCalculator">
        <NumberSystemCalculator />
      </div>
    </div>
  );
}

export default App;
